import { Link } from 'react-router-dom';

interface Column {
  title: string;
  description: string;
  icon: string;
  color: 'primary' | 'accent' | 'secondary';
}

interface FeaturedColumnsProps {
  columns: Column[];
}

const colorMap = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-700',
    badge: 'bg-primary-500',
    hover: 'hover:bg-primary-200/70',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-700',
    badge: 'bg-accent-500',
    hover: 'hover:bg-accent-200/70',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    badge: 'bg-secondary-500',
    hover: 'hover:bg-secondary-200/70',
  },
};

export default function FeaturedColumns({ columns }: FeaturedColumnsProps) {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            特色栏目
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            多元化内容栏目，为您提供全方位的亚洲内容体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {columns.map((column) => {
            const c = colorMap[column.color];
            return (
              <Link
                key={column.title}
                to="/category/wenhua"
                className={`group p-5 md:p-6 rounded-lg bg-background-50 ${c.hover} transition-all duration-300 border border-background-200/70`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${c.badge} text-white mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${column.icon} text-xl`}></i>
                </div>
                <h3 className={`font-heading text-base font-semibold ${c.text} mb-2`}>
                  {column.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {column.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-foreground-400 group-hover:text-foreground-600 transition-colors">
                  了解更多 <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}